import { uploadRestaurantLogoFileHttps } from "../../redux/restaurantsSlice";
import { store } from "../../redux/store";

interface UploadedImgDetails {
  fileExtention: any;
  formData: any;
}

export const uploadImage = async (
  uploadLogoFileExtetion: (data: { fileExtention: string }) => Promise<any>,
  uploadedImgDetails: UploadedImgDetails
): Promise<string> => {

  try {
    const uploadLogoFIleExtentionResult = await uploadLogoFileExtetion({
      fileExtention: uploadedImgDetails.fileExtention,
    });
    const imageUploadUrl = uploadLogoFIleExtentionResult.data.imageUploadUrl;

    await store.dispatch(
      uploadRestaurantLogoFileHttps({
        url: imageUploadUrl,
        body: uploadedImgDetails.formData,
        extention: uploadedImgDetails.fileExtention,
      })
    );
    return uploadLogoFIleExtentionResult.data.imageReference;
  } catch (error) {
    throw error;
  }
};
